import React, { useEffect, useState, useCallback } from 'react';
import { Container, Table, Button, Row, Col, Card, Modal, Spinner } from 'react-bootstrap';
import { LineChart, Line, ResponsiveContainer, XAxis, YAxis, Tooltip } from 'recharts';
import axios from 'axios';
import Title from '../common/Title';
import { contactService } from '../service/contactInfo';
import CommonPagination from '../common/Pagination';
import { toast } from 'react-toastify';
import FormWithContact from '../form/FormWithContact';
import FormWithoutContact from '../form/FormWithoutContact';
import { useAuth } from '../context/AuthContext';

export default function Donations() {
    const baseUrl = 'http://dawsonhighwaycafeandindiancuisine.com/music-dashboard/public';
    const { user, logout } = useAuth();
    const [donationData, setDonationData] = useState([]);
    const [currentItems, setCurrentItems] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedDonation, setSelectedDonation] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [selectedDonationId, setSelectedDonationId] = useState(null);
    const [artists, setArtistsCount] = useState();
    const [allArtists, setArtists] = useState([]);
    const [totalRelease, setReleaseCount] = useState();    
    const [allRelease, setReleases] = useState([]);    
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchArtists = () => {
        const baseUrl = 'http://dawsonhighwaycafeandindiancuisine.com/music-dashboard/public';
        const fetchUrl =
            user.role === 'super_admin' || user.role === 'admin'
                ? '/api/artists'
                : `/api/user/${user.user_id}/artists`;

        axios
            .get(baseUrl + fetchUrl)
            .then((response) => {
                setLoading(true);
                setArtists(response.data.artists);
                setArtistsCount(response.data.artists.length);
            })
            .catch((err) => {
                setError('No Artists Found');
            })
            .finally(() => {
                setLoading(false);
            });
    }
    const fetchReleases = () => {
        const baseUrl = 'http://dawsonhighwaycafeandindiancuisine.com/music-dashboard/public';
        const fetchUrl =
            user.role === 'super_admin' || user.role === 'admin'
                ? '/api/releases'
                : `/api/user/${user.user_id}/releases`;

        axios
            .get(baseUrl + fetchUrl)
            .then((response) => {
                setReleases(response.data.releases);
                setReleaseCount(response.data.releases.length);
            })
            .catch((err) => {
                setError('No Release Found');
            })
            .finally(() => {
                setLoading(false);
            });
    }

    // Initial data fetch
    useEffect(() => {
        fetchArtists();
        fetchReleases();
    }, []);

    const totalAmount = donationData.reduce((total, item) => total + (Number(item.amount) || 0), 0);

    const prepareChartData = useCallback((donations) => {
        return donations.reduce((acc, donation, index) => {
            const entry = {
                name: index,
                donations: index + 1,
                amount: acc[index - 1]
                    ? acc[index - 1].amount + Number(donation.amount || 0)
                    : Number(donation.amount || 0)
            };
            acc.push(entry);
            return acc;
        }, []);
    }, []);

    const handleEdit = useCallback((donation) => {
        setSelectedDonation(donation);
        setShowModal(true);
    }, []);

    const handleCloseModal = useCallback(() => {
        setShowModal(false);
        setSelectedDonation(null);
    }, []);
    const chartData = prepareChartData(donationData);


    const handleShow = async (donation) => {
        try {
            const newShowState = !donation.isShow;
            setSelectedDonation(donation);
            setShow(newShowState);
            setSelectedDonationId((prevId) => (prevId === donation._id ? null : donation._id));

            // Update the database with the new show state
            await contactService.updateContact(donation._id, { isShow: newShowState });

            // Update the local state to reflect the change
            // You'll need to implement this function to update your local state
            updateDonationShowState(donation._id, newShowState);

        } catch (error) {
            toast.error(error?.message || "Something went wrong in hide/show");
        }
    };

    // Add this function to update local state
    const updateDonationShowState = (donationId, newShowState) => {
        setCurrentItems(prevItems =>
            prevItems.map(item =>
                item._id === donationId
                    ? { ...item, isShow: newShowState }
                    : item
            )
        );
    };
    return (
        <Container fluid className="p-3">
            <Row className="mb-4">
                <Col md={9}>
                    <img src="banner1.jpg" alt="Banner" className='img-fluid img-responsive dashboard_banner' />
                    <h4 className='mt-3' style={{fontWeight:"700"}}>Popular Artists <span style={{color:"#9c2e4d"}}> ({artists || 0}) </span> </h4>
                    {loading ? (<Spinner animation="border" variant="primary" />) : (
                        <Row>
                            {allArtists.slice(0,12).map((artist,index) => (
                            <Col md={2}>
                                <div className="card artist_card_wrap">
                                <img
                                    src="user-avatar.png"
                                    className="card-img-top"
                                    alt={`${artist.name}'s avatar`}
                                    style={{ width: '100px', height: '100px', borderRadius: '50%' }}
                                />
                                <div className="card-body text-center">
                                    <h5 className="card-title">{artist.name}</h5>
                                    <p className="card-text"></p>
                                </div>
                            </div>
                            </Col>
                            ))}
                        </Row>
                    )}
                </Col>
                <Col md={3}>
                    <img src="release.jpeg" alt="Banner" className='img-fluid img-responsive dashboard_banner' />
                    <h4 className='mt-3 mb-4' style={{fontWeight:"700"}}>Releases <span style={{color:"#9c2e4d"}}> ({totalRelease || 0}) </span> </h4>
                    {loading ? (<Spinner animation="border" variant="primary" />) : (
                    <div className='release_wrapper_dashboard'>
                    <Row>
                        {allRelease.map((track) => (
                        <Col md={12} key={track.id} className="mb-4">
                            <Card>
                            <Row className="g-0">
                                <Col md={4} className="d-flex justify-content-center align-items-center">
                                <img
                                    src={`${baseUrl}${track.cover_image}`}
                                    alt={`${track.genre} album cover`}
                                    className="rounded-circle"
                                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                />
                                </Col>
                                <Col md={8}>
                                <Card.Body className="text-left">
                                    <Card.Title>{track.artist.name}</Card.Title>
                                    <Card.Text>{track.genre}</Card.Text>
                                    <audio controls style={{width:"100%"}}>
                                        <source src={`${baseUrl}${track.track}`} type="audio/mp3" />
                                    </audio>
                                </Card.Body>
                                </Col>
                            </Row>
                            </Card>
                        </Col>
                        ))}
                    </Row>
                    </div>
                    )}
                </Col>
            </Row>
            {/* <Row>
                <Col md={3}>
                    <Card className="stats_bg text-white">
                        <Card.Body>
                            <Card.Title className="text-white">ARTISTS</Card.Title>
                            <h3>{artists || 0}</h3>
                            <div style={{ height: '150px' }}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <LineChart data={chartData}>
                                        <XAxis dataKey="name" stroke="#fff" />
                                        <YAxis stroke="#fff" />
                                        <Tooltip />
                                        <Line
                                            type="monotone"
                                            dataKey="donations"
                                            stroke="#0d6efd"
                                            strokeWidth={2}
                                            dot={false}
                                        />
                                    </LineChart>
                                </ResponsiveContainer>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card className="stats_bg text-white">
                        <Card.Body>
                            <Card.Title className="text-white">RELEASES</Card.Title>
                            <h3>{totalRelease || 0}</h3>
                            <div style={{ height: '150px' }}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <LineChart data={chartData}>
                                        <XAxis dataKey="name" stroke="#fff" />
                                        <YAxis stroke="#fff" />
                                        <Tooltip />
                                        <Line
                                            type="monotone"
                                            dataKey="amount"
                                            stroke="#198754"
                                            strokeWidth={2}
                                            dot={false}
                                        />
                                    </LineChart>
                                </ResponsiveContainer>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row> */}

            {isLoading ? (
                <div className="text-center">
                    <Spinner animation="border" />
                </div>
            ) : (
                <>
                    
                </>
            )}
        </Container>
    );
}